<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->
    <main-filter @getResult="setRows" is_read_text="الرسائل المقروءة" />
    <!-- <MainLoader v-if="loading"></MainLoader> -->
    <div class="fadeIn">
      <!-- Start Main Section -->
      <main class="row">
        <v-data-table
          class="elevation-1 thumb diff_table col-12"
          :headers="headers"
          :items="messages"
          :search="search"
          :loading="loading"
          :loading-text="$t('table.loadingData')"
          item-key="id"
          :items-per-page="paginations.items_per_page"
          hide-default-footer
        >
          <!-- ================== You Can use any slots you want ================== -->
          <!-- Select no data State -->

          <template v-slot:no-data>
            {{ $t("table.noData") }}
          </template>

          <template v-slot:[`item.index`]="{ index }">
            {{ index + 1 }}
          </template>

          <!-- Start:: Users Routes -->

          <template v-slot:[`item.read_at`]="{ item }">
            <div class="item">
              <p class="title" v-if="item.read_at">{{ item.read_at }}</p>
              <p v-if="!item.read_at" class="unread">غير مقروء</p>
            </div>
          </template>
          <template v-slot:[`item.content`]="{ item }">
            <div class="tw-line-clamp-2 tw-max-w-[150px]">
              {{ item.content }}
            </div>
          </template>

          <template v-slot:[`item.report_reason`]="{ item }">
            <v-icon class="show" small v-if="item.report_reason">
              fal fa-eye
            </v-icon>

            <span v-else>_</span>
          </template>
          <!-- End:: Report Reason Modal Button -->

          <!-- Select actions-->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="_actions d-flex">
              <v-icon
                class="show"
                v-if="!canEdit"
                small
                @click="replyMessage(item)"
              >
                fal fa-reply
              </v-icon>
              <v-icon
                class="delete"
                v-if="!canDelete"
                small
                @click="deleteItem(item)"
              >
                fal fa-trash
              </v-icon>
            </div>
          </template>

          <!-- ======================== Start Top Section ======================== -->
          <template v-slot:top>
            <h3 class="title table-title">عدد الرسائل {{ statisticsItem }}</h3>
            <!-- <h3 class="table-title title">الرسائل الغير مقروءة</h3> -->
            <!-- Delete dialog -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 justify-center">
                  {{ $t("table.deletedialog.areYouSure") }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1B5E20" @click="deleteItemConfirm">
                    {{ $t("table.deletedialog.ok") }}
                  </v-btn>
                  <v-btn color="#F44336" @click="dialogDelete = false">
                    {{ $t("table.deletedialog.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 justify-center">
                  {{ $t("table.deletedialog.areYouSure") }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1B5E20" @click="deleteItemConfirm">
                    {{ $t("table.deletedialog.ok") }}
                  </v-btn>
                  <v-btn color="#F44336" @click="dialogDelete = false">
                    {{ $t("table.deletedialog.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <!-- ======================== End Top Section ======================== -->
        </v-data-table>
        <div v-if="selectedMessage" class="col-lg-3 selected_message">
          <div class="show_message">
            <!-- {{selectedMessage}} -->
            <div class="header">
              <h3>{{ selectedMessage.contact.name }}</h3>
              <div>
                <a
                  v-if="selectedMessage.contact.email"
                  :href="`mailto:${selectedMessage.contact.email}`"
                  target="_blank"
                >
                  <v-icon> mdi-email </v-icon>
                </a>
                <a
                  v-if="selectedMessage.contact.phone"
                  :href="`tel:${selectedMessage.contact.phone}`"
                  target="_blank"
                >
                  <v-icon> mdi-phone </v-icon>
                </a>
                <button
                  @click="selectedMessage = null"
                  style="margin-inline: 6px;"
                >
                  <img src="@/assets/images/Vector.png" alt="" width="15" />
                </button>
              </div>
            </div>

            <div class="message_content">
              <h6>{{ selectedMessage.contact.subject }}</h6>
              <p>{{ selectedMessage.contact.content }}</p>
            </div>
            <span>
              {{ selectedMessage.contact.sent_at }}
            </span>
          </div>
        </div>
        <template>
          <div class="pagination_container tw-text-center mb-5">
            <v-pagination
              v-model="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="6"
              @input="fetchData($event)"
            ></v-pagination>
          </div>
        </template>
      </main>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MainFilter from "../../../components/Filters/MainFilter.vue";

export default {
  props: ["id"],
  components: {
    MainFilter,
  },
  data() {
    return {
      selectedMessage: null,

      messages: [],
      // ========== Statistics
      statisticsItem: null,
      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,
      reportReasonModalIsOpen: false,
      reportReasonToShow: null,

      // ========== Your Data
      rows: [], // injected in created

      // ========== pagination
      paginations: {
        current_page: 0,
        last_page: 0,
        items_per_page: 0,
      },

      // ========== Loading
      loading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.messages.title"),
          disabled: false,
          href: "",
        },
        {
          text: this.$t("breadcrumb.messages.unread"),
          disabled: false,
          href: "",
        },
      ],
      filter: null,
    };
  },
  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "id",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "المرسل",
            align: "center",
            value: "name",
            sortable: true,
          },
          {
            text: "البريد الكتروني",
            align: "center",
            value: "email",
          },
          {
            text: " الهاتف ",
            align: "center",
            value: "phone",
          },
          {
            text: " المحتوي ",
            align: "center",
            value: "content",
          },
          {
            text: "تاريخ الارسال",
            align: "center",
            value: "sent_at",
            sortable: true,
          },
          {
            text: "الاجراءات",
            align: "center",
            value: "actions",
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "id",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
  },
  methods: {
    replyMessage(item) {
      this.$router.push({ path: "/messages/reply/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `contact/${this.itemtoDelete.id}`,
      })
        .then((res) => {
          this.setRows();
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows(e) {
      this.loading = true;
      const params = new URLSearchParams();

      if (e?.is_read) {
        params.append("is_read", e.is_read);
      }
      params.append("page", this.paginations.current_page);
      this.axios({
        method: "GET",
        url: "contact",
        params: params,
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta?.last_page;
          this.paginations.items_per_page = res.data.meta?.per_page;
          this.messages = res.data.data;
          this.statisticsItem = res.data.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    fetchData(e) {
      this.$router.replace({ query: { page: e } }).catch(() => {});
      this.setRows();
    },
  },
  created() {
    this.canEdit = this.$permission.allowed("messages/reply");
    this.canDelete = this.$permission.allowed("messages/delete");
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },
  mounted() {
    // this.setRows()
  },
};
</script>
<style lang="scss">
.selected_message {
  padding: 15px 0px;
  background: #fff;
  // width: 100%;
  height: 100vh;
  border-radius: 15px;
  overflow: scroll;
  box-shadow: 0 2px 8px rgb(0 0 0 / 11%);
  .show_message {
    text-align: center;
    padding-block: 10px;
    font-size: 17px;
    .header {
      background: var(--mainColor-2);
      width: 100%;
      h3 {
        color: #fff;
        line-height: 40px;
      }
    }
    a {
      color: var(--mainColor-2) !important;
    }
    h3 {
      font-size: 19px;
      // color:var(--mainColor-2);
    }
    .details {
      margin-block-start: 10px;
      @include flexCenterAlignment;
      justify-content: space-between;
    }
  }
  .message_content {
    border: 1px solid #eee;
    border-radius: 5px;
    margin-block-start: 20px;
    padding: 10px;
    text-align: center;
    position: relative;
  }
  .recent_messages {
    display: none;
  }
}
.unread {
  background: var(--default);
  padding: 12px 17px;
  border-radius: 7px;
  color: #fff;
  width: fit-content;
  margin: auto;
}
</style>
